export default "__VITE_ASSET__BINJLPv0__"